// New-products rail. Reads from data/products.js instead of the hand-written list that
// previously duplicated images and pinned descriptions to English.
import { Flex, Grid, Text, useColorModeValue } from "@chakra-ui/react";
import React from "react";
import { Link as RouterLink } from "react-router-dom";
import { useTranslation } from "react-i18next";
import Card from "components/Card/Card";
import CardBody from "components/Card/CardBody";
import CardHeader from "components/Card/CardHeader";
import ProductCard from "components/ProductCard/ProductCard";
import { products, newProductsOrder, getImage } from "data/products";

const NewProducts = ({ limit = 8 }) => {
  const { t } = useTranslation("home");
  const headingColor = useColorModeValue("#101A2E", "white");
  const mutedColor = useColorModeValue("#6B7A90", "gray.400");
  const linkColor = useColorModeValue("brand.500", "brand.300");

  const featured = newProductsOrder
    .map((id) => products.find((p) => p.id === id))
    .filter(Boolean)
    .slice(0, limit);

  return (
    <Card p={{ base: "26px", md: "32px" }} my="24px">
      <CardHeader p="0" mb="24px">
        <Flex
          w="100%"
          align={{ base: "flex-start", md: "flex-end" }}
          justify="space-between"
          gap="20px"
          direction={{ base: "column", md: "row" }}
        >
          <Flex direction="column">
            <Text
              fontSize="23px"
              fontWeight="700"
              letterSpacing="-0.028em"
              color={headingColor}
              mb="5px"
            >
              {t("newProducts.title")}
            </Text>
            <Text fontSize="13.5px" color={mutedColor}>
              {t("newProducts.description")}
            </Text>
          </Flex>
          <Text
            as={RouterLink}
            to="/allproducts"
            fontFamily="mono"
            fontSize="11px"
            letterSpacing="0.1em"
            textTransform="uppercase"
            color={linkColor}
            borderBottom="1px solid currentColor"
            pb="2px"
            flex="none"
            _hover={{ textDecoration: "none", opacity: 0.75 }}
          >
            {t("newProducts.viewAll")} →
          </Text>
        </Flex>
      </CardHeader>

      <CardBody p="0" display="block">
        <Grid
          templateColumns={{
            base: "1fr",
            md: "repeat(2, 1fr)",
            lg: "repeat(3, 1fr)",
            xl: "repeat(4, 1fr)",
          }}
          gap="18px"
        >
          {featured.map((product) => (
            <ProductCard
              key={product.id}
              product={product}
              image={product.allProductsImageKey ? getImage(product.allProductsImageKey) : null}
            />
          ))}
        </Grid>
      </CardBody>
    </Card>
  );
};

export default NewProducts;
